import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { inscripcionesOps } from "../../ducks/inscripciones";
import FormularioInscripcion from "./hojaInscripcion/FormularioInscripcion";
import {
  Message,
  Transition,
  Container,
  Segment,
  Header,
  Icon,
  Button
} from "semantic-ui-react";
import BotonCerrar from "../shared/botones/BotonCerrar";

class HojaInscripcion extends React.Component {
  state = {
    showMessage: this.props.dataSaved.status,
    saveMessage: this.props.dataSaved.message,
    colorMessage: "pink",
    iconMessage: "check",
    sizeMessage: "big",
    resguardo: null,
    visible: false
  };

  componentDidMount() {
    const idColegio = this.props.inscribirEnColegio;
    this.setState({ visible: true });
    idColegio !== null &&
      this.props.obtenerDetalleColegio({
        idColegio
      });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showMessage: nextProps.dataSaved.status,
      saveMessage: nextProps.dataSaved.message,
      resguardo: nextProps.dataSaved.resguardo
    });
  }

  componentWillUnmount() {
    this.props.resetInscribirEnColegio();
    this.props.limpiarDetalleColegio();
    this.props.resetDataSaved();
  }

  closeMessage = () => this.setState({ showMessage: false });

  handleGuardarInscripcion = values =>
    this.props.guardarInscripcion({
      values,
      idColegio: this.props.inscribirEnColegio
    });

  render() {
    const { nombre, poblacion, provincia } = this.props.detalleColegio;
    return this.props.inscribirEnColegio === null ? (
      <Redirect to="/inscripciones" />
    ) : (
      <Container>
        <Transition.Group animation="fly down" duration={500}>
          {this.state.showMessage && (
            <Segment
              basic
              style={{
                left: "40%",
                position: "fixed",
                top: "15%",
                zIndex: 1000
              }}
              textAlign="center"
            >
              <Message
                size={this.state.sizeMessage}
                color={this.state.colorMessage}
                onDismiss={this.closeMessage}
              >
                <Header as="h3">{this.state.saveMessage}</Header>
                <div>
                  <Button
                    basic
                    onClick={() => {
                      this.setState({
                        showMessage: false,
                        saveMessage: ""
                      });
                      setTimeout(() => window.print(), 500);
                    }}
                  >
                    <Icon name="print" />
                    Puede Imprimir esta hoja como resguardo.
                  </Button>
                </div>
              </Message>
            </Segment>
          )}
        </Transition.Group>

        <Transition.Group animation="scale" duration={250}>
          {this.state.visible && (
            <Segment basic>
              <Segment textAlign="center">
                <BotonCerrar floated="right" linkTo="/inscripciones" />
                <Header as="h3">
                  {`Inscripción a la Escuela de Verano 2018 del colegio ${nombre}`}
                </Header>
                <div
                >{`Poblacion: ${poblacion} - Provincia: ${provincia} `}</div>
                {this.state.resguardo && (
                  <div>Debe cumplimentar todos los campos.</div>
                )}
                {this.state.resguardo && (
                  <div>
                    <Header as="h4">
                      {`Su número de resguardo es: ${this.state.resguardo}`}
                    </Header>
                    <div>
                      Recuerde que la inscripción no estará completa hasta
                      recibir el justificante de pago en la dirección{" "}
                      <u>escuelas@grupoaristas.com</u>
                    </div>
                    <div>
                      No olvide indicar el nombre del alumno y/o el número de
                      resguardo en el pago o el correo.
                    </div>
                    <div>
                      Una vez completada la inscripción, se le enviará un email
                      de confirmación a la dirección indicada.
                    </div>
                  </div>
                )}
              </Segment>
              <FormularioInscripcion
                resguardo={this.state.resguardo}
                action={this.handleGuardarInscripcion}
                precios={this.props.detalleColegio.precios}
                provincia={this.props.detalleColegio.provincia}
                initialValues={{ ampa: "ampaNo", formaDePago: "efectivo" }}
                colegio={this.props.detalleColegio.nombre}
              />
            </Segment>
          )}
        </Transition.Group>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  inscribirEnColegio: state.inscripciones.inscribirEnColegio,
  dataSaved: state.inscripciones.dataSaved,
  detalleColegio: state.inscripciones.detalleColegio
});

const mapDispatchToProps = {
  resetInscribirEnColegio: inscripcionesOps.resetInscribirEnColegio,
  obtenerDetalleColegio: inscripcionesOps.obtenerDetalleColegio,
  limpiarDetalleColegio: inscripcionesOps.limpiarDetalleColegio,
  guardarInscripcion: inscripcionesOps.guardarInscripcion,
  resetDataSaved: inscripcionesOps.resetDataSaved
};

export default connect(mapStateToProps, mapDispatchToProps)(HojaInscripcion);



// WEBPACK FOOTER //
// ./src/pages/inscripciones/HojaInscripcion.jsx